<template>
  <div class="s-vr">
    <div class="close iconfont icon-close" @click="hide"></div>
    <van-loading ></van-loading>
    <iframe id="myframe" :src="frameSrc" frameborder="0" v-if="show"></iframe>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import rightbox from '../s-rightmenu/rightbox.vue'
export default {
  components: { rightbox },
  name: 'sVrone',
  props: { show:Boolean,src:String},
  data(){
    return{
       frameSrc:null,
       oldframeSrc:null
    }
  },
  watch:{
    src: {
      handler(newv,oldv){
        if(newv){
          console.log(newv,'==newv')
          this.oldframeSrc = newv;
        }
      },immediate:true
    },
    show:{
      handler(newv,oldv){
        if(newv){
          this.frameSrc = this.oldframeSrc
          // this.stopAudio()
        }else{
          this.frameSrc = ''
        }
        this.stopAudio()
      },immediate:true
    }
  },
  mounted() {
    this.stopAudio()
  },
methods:{
   ...mapMutations(['audio/updatePlayState']),
  hide(){
    this.$emit("hide")
    setTimeout(() => {
      this.frameSrc=''
    }, 500);
  },
  stopAudio(){
    this['audio/updatePlayState'](false)
  },

  menuClick(e){
    if(e=='home'){
      this.hide()
      return
    }
    this.$emit("changeMode",{
      old:"vr",
      new:e
    })
  }
},
}
</script>
<style scoped lang="scss">
  .s-vr{
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
    background: #000;
    .van-loading{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      z-index: 1;
    }
    .close{
      position: absolute;
      right: 20rem;
      top: 50rem;
      z-index: 5;
      color: #fff;
      font-size: 24rem;
      cursor: pointer;
      padding: 5rem;
      background: rgba(0, 0, 0, 0.4); 
      border-radius: 5rem;
      text-shadow: 0 0 2rem rgba(0, 0, 0, 0.4);
    }
  }
  #myframe{
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 2;
  }

</style>